import React, { useState, useEffect, useContext } from "react";
import { updateProfile, changePassword, getProfile } from "../../webServices/Apis";
import { message } from "antd";
import Loader from "../Loader/Loader";
import { useNavigate } from "react-router";
import { UserContext } from "../../App";
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';


function Profile() {
  const { setIsAuthenticated } = useContext(UserContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [disableStatus, setDisableStatus] = useState(true);
  const [profileData, setProfileData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    companyName: "",
    address: "",
    startData: "",
    endDate: "",
  });

  const [passwordData, setPasswordData] = useState({
    oldPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });

  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [adminDetails, setAdminDetails] = useState('');
  const [passwordErrors, setPasswordErrors] = useState({});
  const [isOldPasswordVisible, setOldPasswordVisible] = useState(false);
  const [isNewPasswordVisible, setNewPasswordVisible] = useState(false);
  const [isConfirmNewPasswordVisible, setConfirmNewPasswordVisible] = useState(false);

  const closeHandleclose = () => {
    setIsProfileModalOpen(false);
    setProfileData({
      firstName: adminDetails.firstName,
      lastName: adminDetails.lastName,
      email: adminDetails.email,
      address: adminDetails.address,
      companyName: adminDetails.companyName,
      startData: adminDetails.startSubscription,
      endDate: adminDetails.endSubscription
    })
  };

  const closePasswordModal = () => {
    setPasswordData({
      oldPassword: "",
      newPassword: "",
      confirmNewPassword: "",
    }); // Reset password data
    setIsPasswordModalOpen(false);
  };

  const getAdminProfile = async () => {
    setLoading(true);
    try {
      if (!localStorage.getItem("token")) {
        return;
      }
      const response = await getProfile();

      if (response?.data?.success) {
        setAdminDetails(response?.data?.data);
        setProfileData({
          firstName: response.data.data.firstName || "",
          lastName: response.data.data.lastName || "",
          email: response.data.data.email || "",
          address: response.data.data.address || "",
          companyName: response.data.data.companyName || "",
          startData: response.data.data.startSubscription || "",
          endDate: response.data.data.endSubscription || "",
        });
      }
    } catch (error) {
       if (error.message === 'Network Error' || error.message.includes('ERR_INTERNET_DISCONNECTED')) {
             message.error("Network Error")
              return;
            }
            // Handle specific error cases
            if (error?.response?.status === 401 ) {
              window.alert("Your account is logged in to another device, please login again !")
              localStorage.removeItem('token');
              setIsAuthenticated(false)
              window.location.href = "/login";
              return;
            }
            if (error?.response?.status === 500){
              message.error("Server not responding")
              return;
            }
            if (error?.response?.status === 403){
              window.alert("Your subcription has been expired")
              localStorage.clear()
              setIsAuthenticated(false) 
              window.location.href = "/login";
              return;
            }
            else {
              return;
            }

    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAdminProfile();
  }, []);

  const handleProfileChange = (e) => {
    setProfileData({ ...profileData, [e.target.name]: e.target.value });
    setDisableStatus(false);
  };

  const handleProfileSubmit = async (e) => {
    e.preventDefault();

    // Validate form fields
    if (!profileData.firstName.trim() || profileData.firstName.length === 0) {
      message.error("First Name is required");
      return;
    }
    if (!profileData.lastName.trim() || profileData.lastName.length === 0) {
      message.error("Last Name is required");
      return;
    }
    if (profileData.firstName.length > 30) {
      message.error("First Name should not be more than 30 characters");
      return;
    }
    if (profileData.companyName.length === 0 || !profileData.companyName.trim()){
      message.error("Company name is required")
      return;
    }
    if (profileData.address.length === 0 || !profileData.address.trim()){
      message.error("Address field is required")
      return;
    }
    if (profileData.lastName.length > 30) {
      message.error("Last Name should not be more than 30 characters");
      return;
    }
    if (profileData.companyName && profileData.companyName.length > 50) {
      message.error("Company Name should not be more than 50 characters");
      return;
    }
    if (profileData.address && profileData.address.length > 100) {
      message.error("Address should not be more than 100 characters");
      return;
    }
    
    setLoading(true);
    try {
      const response = await updateProfile(profileData);
      setAdminDetails({
        ...adminDetails,
        firstName: profileData.firstName,
        lastName: profileData.lastName,
        companyName: profileData.companyName,
        address: profileData.address
      });
      message.success("Profile updated successfully");
      setIsProfileModalOpen(false);

    } catch (error) {
      message.error(error?.response?.data?.message || "Error updating profile");
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordChange = (e) => {

    setPasswordData({ ...passwordData, [e.target.name]: e.target.value });
    // You can add validation here if needed
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    if (passwordData.newPassword.length === 0 || passwordData.oldPassword.length === 0 || passwordData.confirmNewPassword.length === 0) {
      message.error("All fields are mandatory");
      return;
    }

    if (passwordData.newPassword !== passwordData.confirmNewPassword) {
      message.error("Password and confirm password should be same");
      return;
    }

    setLoading(true)

    try {
      await changePassword(passwordData);
      message.success("Password changed successfully");
      closePasswordModal(); // Close modal after successful password change
    } catch (error) {
      // Check if the error response contains a specific validation message
      if (error?.response?.data) {
        const errorMessage = error.response.data.message || "Error changing password";
        const validationErrors = error.response.data.data;

        // If there are validation errors, concatenate them into a single message
        const detailedMessage = validationErrors
          ? Object.values(validationErrors).join(", ")
          : errorMessage;

        message.error(detailedMessage);
      } else {
        message.error("Error changing password");
      }
    } finally {
      setLoading(false)
    }
  };


  function formatDate(dateString) {
    const date = new Date(dateString); // Parse the date string
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month (0-indexed, so add 1)
    const day = String(date.getDate()).padStart(2, '0'); // Get day
    const year = date.getFullYear(); // Get year

    return `${month}-${day}-${year}`; // Return formatted date as mm/dd/yyyy
  }


  return loading ? (
    <Loader />
  ) : (
    <div className="bg-gray-200 text-black p-10 h-4/7 w-4/6 rounded-lg shadow-2xl shadow-blue-300 mt-10 ml-48">
      <div className="w-full text-center mb-8">
        <h2 className="text-3xl font-extrabold mb-2">{`${adminDetails.firstName || ""} ${adminDetails.lastName || ""}`}</h2>
        <p className="text-xl font-semibold text-blue-600">{adminDetails.email}</p>
      </div>

      <div className="grid grid-cols-1 gap-4">
        <div className="flex justify-start items-center">
          <p className="text-lg font-bold text-black w-1/3">Company Name:</p>
          <p className="text-lg font-semibold text-gray-700 w-2/3">
            {adminDetails.companyName || "N/A"}
          </p>
        </div>


        <div className="flex justify-start items-center">
          <p className="text-lg font-bold text-black w-1/3">Address:</p>
          <p className="text-lg font-semibold text-gray-700 w-2/3">
            {adminDetails.address || "N/A"}
          </p>
        </div>

        <div className="flex justify-start items-center">
          <p className="text-lg font-bold text-black w-1/3">Subscription Start:</p>
          <p className="text-lg font-semibold text-gray-700 w-2/3">
            {adminDetails.startSubscription ? formatDate(adminDetails.startSubscription) : "N/A"}
          </p>
        </div>
        <div className="flex justify-start items-center">
          <p className="text-lg font-bold text-black w-1/3">Subscription End:</p>
          <p className="text-lg font-semibold text-gray-700 w-2/3">
            {adminDetails.endSubscription ? formatDate(adminDetails.endSubscription) : "N/A"}
          </p>
        </div>
      </div>


      <div className="mt-10 w-full flex justify-end">
      {adminDetails?.role === 'Contractor' ? (
        <button
          onClick={() => setIsProfileModalOpen(true)}
          className="border border-blue-500 bg-blue-300 text-gray-900 px-6 py-3 rounded-md hover:bg-blue-500 transition mr-4 shadow-md shadow-blue-500"
        >
          Update Profile
        </button>
      ) : (
        <div></div>
      )}
        <button
          onClick={() => setIsPasswordModalOpen(true)}
          className="border border-green-500 bg-green-300 text-gray-900 px-6 py-3 rounded-md hover:bg-green-500 transition shadow-md shadow-green-500"
        >
          Change Password
        </button>
      </div>

      {/* Modal for Update Profile */}
      {isProfileModalOpen && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-md">
            <h3 className="text-2xl font-semibold mb-4 text-white bg-blue-950 w-full py-1 text-center">
              Update Profile
            </h3>
            <form onSubmit={handleProfileSubmit} className="p-8">
              <div className="mb-4">
                <label className="block mb-1 text-gray-700" htmlFor="firstName">
                  First Name
                </label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={profileData.firstName}
                  onChange={handleProfileChange}
                  className="w-full px-4 py-2 border border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                />
              </div>
              <div className="mb-4">
                <label className="block mb-1 text-gray-700" htmlFor="lastName">
                  Last Name
                </label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={profileData.lastName}
                  onChange={handleProfileChange}
                  className="w-full px-4 py-2 border border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                />
              </div>
              <div>
                <label className="block mb-1 text-gray-700" htmlFor="companyName">
                  Company Name
                </label>
                <input
                  type="text"
                  id="companyName"
                  name="companyName"
                  value={profileData.companyName}
                  onChange={handleProfileChange}
                  className="w-full px-4 py-2 border border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                />
              </div>

              <div>
                <label className="block mt-3 mb-1 text-gray-700" htmlFor="address">
                  Address
                </label>
                <input
                  type="text"
                  id="address"
                  name="address"
                  value={profileData.address}
                  onChange={handleProfileChange}
                  className="w-full px-4 py-2 border border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                />
              </div>

              <div className="flex justify-between mt-4 gap-2">
                <button
                  type="button"
                  className="bg-gray-300 text-black w-52 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200"
                  onClick={closeHandleclose}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  // disabled={disableStatus}
                  className="bg-blue-500 text-white py-2 px-4 rounded-md w-52 hover:bg-blue-600 transition duration-200 mr-2"
                >
                  Update Profile
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal for Change Password */}
      {isPasswordModalOpen && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-md">
            <h3 className="text-2xl font-semibold mb-4 text-white bg-blue-950 w-full py-1 text-center">
              Change Password
            </h3>
            <form onSubmit={handlePasswordSubmit} className="p-8">
              <div className="relative mb-4">
                <label className="block mb-1 text-gray-700" htmlFor="oldPassword">
                  Old Password
                </label>
                <input
                  type={isOldPasswordVisible ? "text" : "password"}
                  id="oldPassword"
                  name="oldPassword"
                  value={passwordData.oldPassword}
                  onChange={handlePasswordChange}
                  className="w-full px-4 py-2 border border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                />
                <button
                  type="button"
                  onClick={() => setOldPasswordVisible(!isOldPasswordVisible)}
                  className="absolute right-2 top-10"
                >
                  {isOldPasswordVisible ? <AiFillEye /> : <AiFillEyeInvisible />}
                </button>
              </div>

              <div className="relative mb-4">
                <label className="block mb-1 text-gray-700" htmlFor="newPassword">
                  New Password
                </label>
                <input
                  type={isNewPasswordVisible ? "text" : "password"}
                  id="newPassword"
                  name="newPassword"
                  value={passwordData.newPassword}
                  onChange={handlePasswordChange}
                  className="w-full px-4 py-2 border border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                />
                <button
                  type="button"
                  onClick={() => setNewPasswordVisible(!isNewPasswordVisible)}
                  className="absolute right-2 top-10"
                >
                  {isNewPasswordVisible ? <AiFillEye /> : <AiFillEyeInvisible />}
                </button>
              </div>

              <div className="relative mb-4">
                <label className="block mb-1 text-gray-700" htmlFor="confirmNewPassword">
                  Confirm New Password
                </label>
                <input
                  type={isConfirmNewPasswordVisible ? "text" : "password"}
                  id="confirmNewPassword"
                  name="confirmNewPassword"
                  value={passwordData.confirmNewPassword}
                  onChange={handlePasswordChange}
                  className="w-full px-4 py-2 border border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                />
                <button
                  type="button"
                  onClick={() => setConfirmNewPasswordVisible(!isConfirmNewPasswordVisible)}
                  className="absolute right-2 top-10"
                >
                  {isConfirmNewPasswordVisible ? <AiFillEye /> : <AiFillEyeInvisible />}
                </button>
              </div>

              <div className="flex justify-between mt-4 gap-2">
                <button
                  type="button"
                  className="bg-gray-300 text-black w-52 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200"
                  onClick={closePasswordModal}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-blue-500 text-white py-2 px-4 rounded-md w-52 hover:bg-blue-600 transition duration-200 mr-2"
                >
                  Change Password
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Profile;
